(function () {
  var ELEMENT_NAME = 'complete-the-look';

  if (!('customElements' in window) || customElements.get(ELEMENT_NAME)) {
    return;
  }

  var htmlEscapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };
  var CART_FRAGMENT_SELECTORS = [
    '#MinimogCartDrawer [data-minimog-cart-items]',
    '#MinimogCartDrawerFooter',
    '#MinimogCart [data-minimog-cart-items]',
    '#MinimogCartFooter',
    '[data-minimog-cart-discounts]',
    '[data-minimog-gift-wrapping]',
    '[data-cart-subtotal]',
    '[data-cart-subtotal-price]',
    'cart-notification',
    '#cart-notification',
    '#cart-icon-bubble',
    '.cart-count-bubble',
    '[data-cart-count-bubble]',
    '[data-cart-count]',
    '.sf-cart-count',
    '.m-cart-count'
  ];
  var CART_COUNT_SELECTORS = [
    '[data-cart-count]',
    '[data-cart-count-bubble]',
    '[data-cart-item-count]',
    '[data-cart-items-count]',
    '[data-cart-count-number]',
    '[data-header-cart-count]',
    '[data-cart-bubble]',
    '[data-cart-icon-bubble]',
    '.cart-count',
    '.cart-count-bubble span[aria-hidden="true"]',
    '.cart-count-bubble',
    '.header-cart-count',
    '.header__cart-count',
    '.site-header__cart-count',
    '.sf-cart-count',
    '.m-cart-count',
    '.m-cart-count-bubble',
    '.m-cart-icon-bubble',
    '.m-header__cart-count',
    '.m-header__cart-counter',
    '.m-cart-icon__count',
    'a[href*="/cart"] [class*="count"]',
    'a[href*="/cart"] [class*="bubble"]',
    'button[class*="cart"] [class*="count"]',
    'button[class*="cart"] [class*="bubble"]'
  ];
  var CART_COUNT_SELECTOR = CART_COUNT_SELECTORS.join(',');
  var CART_COUNT_TARGET_SELECTORS = [
    '[data-cart-count]',
    '[data-cart-count-bubble]',
    '[data-cart-item-count]',
    '[data-cart-items-count]',
    '[data-cart-count-number]',
    '.cart-count',
    '.cart-count-bubble',
    '.m-cart-count',
    '.m-cart-count-bubble',
    '.m-cart-icon-bubble',
    '.count'
  ];
  var CART_COUNT_ELEMENT_SELECTOR = [
    '.cart-count',
    '.cart-count-bubble',
    '[data-cart-count-bubble]',
    '[data-cart-count]',
    '.m-cart-count',
    '.m-cart-count-bubble',
    '.m-cart-icon-bubble',
    '.m-cart-icon__count'
  ].join(',');
  var CART_ICON_CONTAINERS = [
    '#cart-icon-bubble',
    '.cart-icon-bubble',
    '[data-cart-icon-bubble]',
    '.m-cart-icon-bubble',
    '.m-cart-icon',
    '.m-header__cart',
    'header a[href*="/cart"]',
    'header button[class*="cart"]',
    '.header a[href*="/cart"]',
    '.header button[class*="cart"]',
    '.site-header a[href*="/cart"]',
    '.site-header button[class*="cart"]',
    '.m-header a[href*="/cart"]',
    '.m-header button[class*="cart"]'
  ];
  var CART_ICON_CONTAINER_SELECTOR = CART_ICON_CONTAINERS.join(',');
  var CART_OPEN_TRIGGER_SELECTOR = [
    '[data-open-cart-drawer]',
    '[data-cart-drawer-trigger]',
    '[data-drawer-trigger="cart"]',
    '[data-drawer-target="cart-drawer"]',
    '[data-action="open-cart-drawer"]',
    '[aria-controls="cart-drawer"]',
    '[aria-controls="MinimogCartDrawer"]',
    '[href="#cart-drawer"]'
  ].join(',');

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return htmlEscapeMap[char];
    });
  }

  function normalizeRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  function localizedPath(path) {
    var root = normalizeRoot();
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function normalizeId(id) {
    if (id == null) return null;
    return String(id);
  }

  function isVariantAvailable(variant) {
    return Boolean(variant && variant.available);
  }

  function getOptionNames(product) {
    if (!product || !Array.isArray(product.options)) return [];

    return product.options
      .map(function (option) {
        return typeof option === 'string' ? option : option && option.name;
      })
      .filter(Boolean);
  }

  function getVariantValue(variant, optionIndex) {
    if (!variant) return '';
    if (Array.isArray(variant.options)) return variant.options[optionIndex] || '';
    return variant['option' + (optionIndex + 1)] || '';
  }

  function getVariantOptions(product, variant) {
    var optionNames = getOptionNames(product);
    var options = {};

    optionNames.forEach(function (optionName, index) {
      options[optionName] = getVariantValue(variant, index);
    });

    return options;
  }

  function sameValue(a, b) {
    return String(a || '').toLowerCase() === String(b || '').toLowerCase();
  }

  function normalizeLockedOptions(lockedOptions, optionNames) {
    var normalized = {};
    var locked = lockedOptions || {};

    Object.keys(locked).forEach(function (lockedName) {
      var matchedName =
        optionNames.find(function (optionName) {
          return sameValue(optionName, lockedName);
        }) || lockedName;

      normalized[matchedName] = locked[lockedName];
    });

    return normalized;
  }

  function variantMatchesSelections(product, variant, selections) {
    var optionNames = getOptionNames(product);

    return optionNames.every(function (optionName, index) {
      if (selections[optionName] == null || selections[optionName] === '') {
        return true;
      }

      return String(getVariantValue(variant, index)) === String(selections[optionName]);
    });
  }

  function uniqueValues(values) {
    var seen = Object.create(null);

    return values.filter(function (value) {
      var key = String(value);
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function urlWithVariant(url, variantId) {
    if (!url || !variantId) return url;

    try {
      var parsedUrl = new URL(url, window.location.href);
      parsedUrl.searchParams.set('variant', String(variantId));

      if (parsedUrl.origin === window.location.origin) {
        return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
      }

      return parsedUrl.toString();
    } catch (error) {
      var cleanUrl = String(url).replace(/([?&])variant=[^&#]*(&?)/, function (match, prefix, suffix) {
        return suffix ? prefix : '';
      });
      return cleanUrl + (cleanUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variantId);
    }
  }

  function normalizeImageUrl(image) {
    if (!image) return '';

    image = String(image);
    if (image.indexOf('//') === 0) {
      image = window.location.protocol + image;
    }

    return image;
  }

  function imageUrlWithWidth(image, width) {
    image = normalizeImageUrl(image);

    if (!image || image.indexOf('cdn.shopify.com') === -1) {
      return image;
    }

    try {
      var url = new URL(image, window.location.href);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      var cleanImage = image.replace(/([?&])width=\d+(&?)/, function (match, prefix, suffix) {
        return suffix ? prefix : '';
      });
      return cleanImage + (cleanImage.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }
  }

  function productImageUrl(product, variant) {
    var image = null;

    if (variant && variant.featured_image) {
      image = variant.featured_image.src || variant.featured_image;
    }

    if (!image && product && product.featured_image) {
      image = product.featured_image.src || product.featured_image;
    }

    if (!image && product && Array.isArray(product.images) && product.images.length) {
      image = product.images[0].src || product.images[0];
    }

    if (!image) return '';

    return imageUrlWithWidth(image, 640);
  }

  function productImageSrcset(image) {
    image = normalizeImageUrl(image);

    if (!image || image.indexOf('cdn.shopify.com') === -1) {
      return '';
    }

    return [320, 480, 640, 800].map(function (width) {
      return imageUrlWithWidth(image, width) + ' ' + width + 'w';
    }).join(', ');
  }

  function productUrl(product, variant) {
    var url = product && product.url;

    if (!url && product && product.handle) {
      url = localizedPath('products/' + product.handle);
    }

    if (!url) return '#';
    if (variant && variant.id) {
      url = urlWithVariant(url, variant.id);
    }

    return url;
  }

  function parseHtml(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function uniquePush(list, value) {
    if (value && list.indexOf(value) === -1) {
      list.push(value);
    }
  }

  function currentSectionsUrl() {
    return (window.location.pathname || '/') + (window.location.search || '');
  }

  function isSvgElement(element) {
    return Boolean(
      element &&
      (
        String(element.tagName || '').toLowerCase() === 'svg' ||
        String(element.namespaceURI || '').indexOf('svg') !== -1
      )
    );
  }

  function isLikelyCartIconContainer(element) {
    if (!element || typeof element.matches !== 'function') return false;

    if (
      element.matches(
        '#cart-icon-bubble, .cart-icon-bubble, [data-cart-icon-bubble], .m-cart-icon-bubble, .m-cart-icon, .m-header__cart'
      )
    ) {
      return true;
    }

    var label = [
      element.getAttribute('aria-label'),
      element.getAttribute('title'),
      element.id,
      element.className
    ].join(' ');

    if (/cart|bag|shopping/i.test(label)) {
      return true;
    }

    return Boolean(element.querySelector('svg, [class*="cart"], [class*="bag"], [class*="icon"]'));
  }

  class CompleteTheLook extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.loading = false;
      this.errorMessage = '';
      this.addEventListener('change', this.handleChange.bind(this));
      this.addEventListener('click', this.handleClick.bind(this));

      this.config = this.readConfig();
      if (!this.config) {
        this.hidden = true;
        return;
      }

      this.products = Array.isArray(this.config.products) ? this.config.products : [];
      this.itemStates = (Array.isArray(this.config.items) ? this.config.items : [])
        .map(this.createItemState.bind(this))
        .filter(Boolean);

      this.itemStates.forEach(function (state, index) {
        state.index = index;
      });

      if (this.itemStates.length < 2) {
        this.hidden = true;
        return;
      }

      this.render();
    }

    readConfig() {
      var script = this.querySelector('[data-complete-the-look-config]');
      if (!script) return null;

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error('Complete the look config is invalid.', error);
        return null;
      }
    }

    createItemState(item, index) {
      var product = this.products[item.productIndex];
      if (!product || !Array.isArray(product.variants) || !product.variants.length) {
        return null;
      }

      var optionNames = getOptionNames(product);
      var lockedOptions = normalizeLockedOptions(item.lockedOptions, optionNames);
      var state = {
        index: index,
        role: item.role || '',
        label: item.label || product.title || '',
        product: product,
        optionNames: optionNames,
        lockedOptions: lockedOptions,
        selections: Object.assign({}, lockedOptions),
        selected: false,
        selectedVariant: null,
        displayVariant: null,
        defaultVariantId: normalizeId(item.defaultVariantId)
      };

      var initialVariant = this.findInitialVariant(state);
      this.applyVariant(state, initialVariant || this.findFirstVariantMatchingLockedOptions(state));

      if (!initialVariant || !isVariantAvailable(initialVariant)) {
        state.selectedVariant = null;
      }

      state.selected = Boolean(state.selectedVariant);

      return state;
    }

    findInitialVariant(state) {
      var product = state.product;
      var preferredId = state.defaultVariantId;

      if (preferredId) {
        var preferredVariant = product.variants.find(function (variant) {
          return normalizeId(variant.id) === preferredId;
        });

        if (
          preferredVariant &&
          isVariantAvailable(preferredVariant) &&
          variantMatchesSelections(product, preferredVariant, state.lockedOptions)
        ) {
          return preferredVariant;
        }
      }

      return product.variants.find(function (variant) {
        return isVariantAvailable(variant) && variantMatchesSelections(product, variant, state.lockedOptions);
      });
    }

    findFirstVariantMatchingLockedOptions(state) {
      return state.product.variants.find(function (variant) {
        return variantMatchesSelections(state.product, variant, state.lockedOptions);
      });
    }

    applyVariant(state, variant) {
      if (!variant) {
        state.displayVariant = null;
        state.selectedVariant = null;
        return;
      }

      state.selections = Object.assign(
        {},
        getVariantOptions(state.product, variant),
        state.lockedOptions
      );
      state.displayVariant = variant;
      state.selectedVariant = isVariantAvailable(variant) ? variant : null;
    }

    getSelectableOptionNames(state) {
      if (state.product.has_only_default_variant) return [];

      return state.optionNames.filter(function (optionName) {
        if (Object.prototype.hasOwnProperty.call(state.lockedOptions, optionName)) {
          return false;
        }

        var values = this.getOptionValues(state, optionName);
        if (values.length <= 1) {
          return false;
        }

        return !(sameValue(optionName, 'Title') && values.length === 1 && sameValue(values[0], 'Default Title'));
      }, this);
    }

    getOptionValues(state, optionName) {
      var optionIndex = state.optionNames.indexOf(optionName);
      if (optionIndex === -1) return [];

      var values = state.product.variants
        .filter(function (variant) {
          return variantMatchesSelections(state.product, variant, state.lockedOptions);
        })
        .map(function (variant) {
          return getVariantValue(variant, optionIndex);
        })
        .filter(Boolean);

      return uniqueValues(values);
    }

    hasAvailableVariantForChoice(state, optionName, value) {
      var selections = Object.assign({}, state.selections, state.lockedOptions);
      selections[optionName] = value;

      return state.product.variants.some(function (variant) {
        return isVariantAvailable(variant) && variantMatchesSelections(state.product, variant, selections);
      });
    }

    handleOptionChange(itemIndex, optionName, value) {
      var state = this.itemStates[itemIndex];
      if (!state) return;
      var items = this.querySelector('.complete-the-look__items');
      var scrollLeft = items ? items.scrollLeft : 0;

      state.selections[optionName] = value;
      this.errorMessage = '';

      var nextVariant = state.product.variants.find(function (variant) {
        return isVariantAvailable(variant) && variantMatchesSelections(state.product, variant, state.selections);
      });

      if (!nextVariant) {
        nextVariant = state.product.variants.find(function (variant) {
          var partialSelections = Object.assign({}, state.lockedOptions);
          partialSelections[optionName] = value;
          return isVariantAvailable(variant) && variantMatchesSelections(state.product, variant, partialSelections);
        });
      }

      this.applyVariant(state, nextVariant || null);
      if (!state.selectedVariant) {
        state.selected = false;
      }
      this.updateItemDom(state, { changedOptionName: optionName });
      this.updateFooter();
      this.restoreItemsScroll(scrollLeft);
    }

    handleItemToggle(itemIndex, selected) {
      var state = this.itemStates[itemIndex];
      if (!state || !state.selectedVariant) return;
      var items = this.querySelector('.complete-the-look__items');
      var scrollLeft = items ? items.scrollLeft : 0;

      state.selected = selected;
      this.errorMessage = '';
      this.updateItemDom(state);
      this.updateFooter();
      this.restoreItemsScroll(scrollLeft);
    }

    getSelectedStates() {
      return this.itemStates.filter(function (state) {
        return state.selected && state.selectedVariant;
      });
    }

    restoreItemsScroll(scrollLeft) {
      var restore = function () {
        var items = this.querySelector('.complete-the-look__items');
        if (items) {
          items.scrollLeft = scrollLeft;
        }
      }.bind(this);

      restore();
      window.requestAnimationFrame(restore);
      window.setTimeout(restore, 60);
    }

    formatMoney(cents) {
      var amount = Number(cents || 0);

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(amount, this.config.moneyFormat);
      }

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.config.currencyCode || 'USD'
        }).format(amount / 100);
      } catch (error) {
        return (amount / 100).toFixed(2);
      }
    }

    renderPrice(state) {
      var variant = state.selectedVariant || state.displayVariant;
      if (!variant || variant.price == null) return '';

      var price = Number(variant.price);
      var compareAtPrice = Number(variant.compare_at_price || 0);
      var priceHtml = '<span class="complete-the-look__price-current">' + escapeHtml(this.formatMoney(price)) + '</span>';

      if (compareAtPrice > price) {
        priceHtml +=
          ' <s class="complete-the-look__price-compare">' +
          escapeHtml(this.formatMoney(compareAtPrice)) +
          '</s>';
      }

      return '<div class="complete-the-look__price">' + priceHtml + '</div>';
    }

    renderControls(state) {
      var selectableOptionNames = this.getSelectableOptionNames(state);
      if (!selectableOptionNames.length) return '';
      var controlsDisabled = !state.selected || !state.selectedVariant;

      return (
        '<div class="complete-the-look__controls">' +
        selectableOptionNames
          .map(function (optionName) {
            var values = this.getOptionValues(state, optionName);
            var selectedValue = state.selections[optionName] || values[0] || '';

            return (
              '<label class="complete-the-look__control">' +
              '<span class="complete-the-look__control-label">' +
              escapeHtml(optionName) +
              '</span>' +
              '<select class="complete-the-look__select" data-item-index="' +
              state.index +
              '" data-option-name="' +
              escapeHtml(optionName) +
              '"' +
              (controlsDisabled ? ' disabled' : '') +
              '>' +
              values
                .map(function (value) {
                  var disabled = !this.hasAvailableVariantForChoice(state, optionName, value);
                  var selected = String(value) === String(selectedValue);

                  return (
                    '<option value="' +
                    escapeHtml(value) +
                    '"' +
                    (selected ? ' selected' : '') +
                    (disabled ? ' disabled' : '') +
                    '>' +
                    escapeHtml(value) +
                    '</option>'
                  );
                }, this)
                .join('') +
              '</select>' +
              '</label>'
            );
          }, this)
          .join('') +
        '</div>'
      );
    }

    renderItem(state) {
      var variant = state.selectedVariant || state.displayVariant;
      var image = productImageUrl(state.product, variant);
      var imageSrcset = productImageSrcset(image);
      var isUnavailable = !state.selectedVariant;
      var link = productUrl(state.product, variant);
      var hasProductLink = state.role === 'complementary_product';
      var isProductLinkActive = hasProductLink && state.selected && !isUnavailable;
      var disabledLinkAttributes = ' aria-disabled="true" tabindex="-1"';
      var imageLoading = state.index < 2 ? 'eager' : 'lazy';
      var imageFetchPriority = state.index < 2 ? 'high' : 'auto';
      var toggleHtml =
        '<label class="complete-the-look__toggle">' +
        '<input class="complete-the-look__checkbox" type="checkbox" data-toggle-item-index="' +
        state.index +
        '" aria-label="' +
        escapeHtml('Select ' + (state.label || state.product.title)) +
        '"' +
        (state.selected ? ' checked' : '') +
        (isUnavailable ? ' disabled' : '') +
        '>' +
        '<span class="complete-the-look__checkmark" aria-hidden="true"></span>' +
        '</label>';
      var mediaHtml =
        '<div class="complete-the-look__media">' +
        '<div class="complete-the-look__image-frame">' +
        (hasProductLink
          ? '<a class="complete-the-look__media-link" data-ctl-href="' +
            escapeHtml(link) +
            '"' +
            (isProductLinkActive ? ' href="' + escapeHtml(link) + '"' : disabledLinkAttributes) +
            '>'
          : '') +
        (image
          ? '<img src="' +
            escapeHtml(image) +
            '" data-ctl-src="' +
            escapeHtml(image) +
            '" data-ctl-srcset="' +
            escapeHtml(imageSrcset) +
            '" alt="' +
            escapeHtml(state.label || state.product.title) +
            '"' +
            (imageSrcset ? ' srcset="' + escapeHtml(imageSrcset) + '" sizes="(max-width: 640px) 46vw, 260px"' : '') +
            ' loading="' +
            imageLoading +
            '" fetchpriority="' +
            imageFetchPriority +
            '" decoding="async">'
          : '<span class="complete-the-look__image-placeholder" aria-hidden="true"></span>') +
        (hasProductLink ? '</a>' : '') +
        toggleHtml +
        '</div>' +
        '</div>';
      var titleText = escapeHtml(state.label || state.product.title);
      var titleHtml = hasProductLink
        ? '<a class="complete-the-look__title" data-ctl-href="' +
          escapeHtml(link) +
          '"' +
          (isProductLinkActive ? ' href="' + escapeHtml(link) + '"' : disabledLinkAttributes) +
          '>' +
          titleText +
          '</a>'
        : '<span class="complete-the-look__title">' + titleText + '</span>';

      return (
        '<article class="complete-the-look__item' +
        (isUnavailable ? ' is-unavailable' : '') +
        (state.selected ? ' is-selected' : '') +
        '" data-item-index="' +
        state.index +
        '">' +
        mediaHtml +
        '<div class="complete-the-look__details">' +
        '<div class="complete-the-look__title-row">' +
        titleHtml +
        (isUnavailable ? '<span class="complete-the-look__badge">Unavailable</span>' : '') +
        '</div>' +
        this.renderPrice(state) +
        this.renderControls(state) +
        '</div>' +
        '</article>'
      );
    }

    renderTotalHtml() {
      var selectedStates = this.getSelectedStates();
      var selectedCount = selectedStates.length;
      var total = selectedStates.reduce(function (sum, state) {
        return sum + Number((state.selectedVariant && state.selectedVariant.price) || 0);
      }, 0);

      if (!selectedCount) {
        return '<div class="complete-the-look__summary-line"><span>0 selected</span></div>';
      }

      return (
        '<div class="complete-the-look__summary-line">' +
        '<span>' +
        selectedCount +
        ' selected</span>' +
        '<strong>' +
        escapeHtml(this.formatMoney(total)) +
        '</strong>' +
        '</div>'
      );
    }

    getStatusMessage() {
      return this.errorMessage || '';
    }

    render() {
      var selectedCount = this.getSelectedStates().length;
      var statusMessage = this.getStatusMessage();

      this.innerHTML =
        '<div class="complete-the-look__inner">' +
        (this.config.showHeading === false
          ? ''
          : '<div class="complete-the-look__heading">' +
            escapeHtml(this.config.heading || 'Complete the look') +
            '</div>') +
        '<div class="complete-the-look__items">' +
        this.itemStates.map(this.renderItem.bind(this)).join('') +
        '</div>' +
        '<div class="complete-the-look__footer">' +
        '<div class="complete-the-look__total" aria-live="polite">' +
        this.renderTotalHtml() +
        '</div>' +
        '<button type="button" class="complete-the-look__button m-button m-button--primary sf__btn sf__btn-primary btn btn-primary"' +
        (selectedCount > 0 && !this.loading ? '' : ' disabled') +
        '>' +
        escapeHtml(this.loading ? 'Adding...' : this.config.buttonLabel || 'Add selected') +
        '</button>' +
        (statusMessage
          ? '<p class="complete-the-look__message' +
            ' is-error' +
            '" role="status">' +
            escapeHtml(statusMessage) +
            '</p>'
          : '') +
        '</div>' +
        '</div>';
    }

    handleChange(event) {
      if (!event.target || typeof event.target.closest !== 'function') return;

      var select = event.target.closest('[data-option-name]');
      if (select && this.contains(select)) {
        this.handleOptionChange(
          Number(select.dataset.itemIndex),
          select.dataset.optionName,
          select.value
        );
        return;
      }

      var checkbox = event.target.closest('[data-toggle-item-index]');
      if (checkbox && this.contains(checkbox)) {
        event.stopPropagation();
        this.handleItemToggle(Number(checkbox.dataset.toggleItemIndex), checkbox.checked);
      }
    }

    handleClick(event) {
      if (!event.target || typeof event.target.closest !== 'function') return;

      var checkbox = event.target.closest('[data-toggle-item-index]');
      if (checkbox && this.contains(checkbox)) {
        event.stopPropagation();
        return;
      }

      var productLink = event.target.closest('.complete-the-look__media-link, .complete-the-look__title[data-ctl-href]');
      if (productLink && this.contains(productLink)) {
        var item = productLink.closest('.complete-the-look__item');
        if (
          !item ||
          !item.classList.contains('is-selected') ||
          item.classList.contains('is-unavailable') ||
          productLink.getAttribute('aria-disabled') === 'true'
        ) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
      }

      var button = event.target.closest('.complete-the-look__button');
      if (button && this.contains(button)) {
        this.handleSubmit();
      }
    }

    updateItemDom(state, options) {
      var item = this.querySelector('.complete-the-look__item[data-item-index="' + state.index + '"]');
      if (!item) return;

      var isUnavailable = !state.selectedVariant;
      item.classList.toggle('is-unavailable', isUnavailable);
      item.classList.toggle('is-selected', Boolean(state.selected));

      var checkbox = item.querySelector('[data-toggle-item-index]');
      if (checkbox) {
        checkbox.checked = Boolean(state.selected);
        checkbox.disabled = isUnavailable;
      }

      var titleRow = item.querySelector('.complete-the-look__title-row');
      var badge = item.querySelector('.complete-the-look__badge');
      if (isUnavailable && !badge && titleRow) {
        badge = document.createElement('span');
        badge.className = 'complete-the-look__badge';
        badge.textContent = 'Unavailable';
        titleRow.appendChild(badge);
      } else if (!isUnavailable && badge) {
        badge.remove();
      }

      this.updateItemPriceDom(item, state);
      this.updateItemControlsDom(item, state);
      this.updateItemMediaDom(item, state, options || {});
    }

    updateItemPriceDom(item, state) {
      var priceNode = item.querySelector('.complete-the-look__price');
      var controlsNode = item.querySelector('.complete-the-look__controls');
      var priceHtml = this.renderPrice(state);

      if (priceNode && priceHtml) {
        priceNode.outerHTML = priceHtml;
        return;
      }

      if (priceNode && !priceHtml) {
        priceNode.remove();
        return;
      }

      if (!priceNode && priceHtml) {
        if (controlsNode) {
          controlsNode.insertAdjacentHTML('beforebegin', priceHtml);
        } else {
          var details = item.querySelector('.complete-the-look__details');
          if (details) details.insertAdjacentHTML('beforeend', priceHtml);
        }
      }
    }

    updateItemControlsDom(item, state) {
      var controlsDisabled = !state.selected || !state.selectedVariant;

      item.querySelectorAll('[data-option-name]').forEach(function (select) {
        var optionName = select.dataset.optionName;
        var values = this.getOptionValues(state, optionName);
        var selectedValue = state.selections[optionName] || values[0] || '';

        select.disabled = controlsDisabled;

        Array.prototype.slice.call(select.options).forEach(function (option) {
          var value = option.value;
          option.selected = String(value) === String(selectedValue);
          option.disabled = !this.hasAvailableVariantForChoice(state, optionName, value);
        }, this);
      }, this);
    }

    updateItemMediaDom(item, state, options) {
      var variant = state.selectedVariant || state.displayVariant;
      var link = productUrl(state.product, variant);
      var productLinkNodes = item.querySelectorAll('.complete-the-look__media-link, .complete-the-look__title[data-ctl-href]');
      var isProductLinkActive = state.role === 'complementary_product' && state.selected && state.selectedVariant;

      if (state.role === 'complementary_product') {
        productLinkNodes.forEach(function (linkNode) {
          linkNode.dataset.ctlHref = link;

          if (isProductLinkActive) {
            linkNode.href = link;
            linkNode.removeAttribute('aria-disabled');
            linkNode.removeAttribute('tabindex');
          } else {
            linkNode.removeAttribute('href');
            linkNode.setAttribute('aria-disabled', 'true');
            linkNode.setAttribute('tabindex', '-1');
          }
        });
      }

      if (options.changedOptionName && sameValue(options.changedOptionName, this.config.sizeOptionName || 'Size')) {
        return;
      }

      var image = productImageUrl(state.product, variant);
      var imageSrcset = productImageSrcset(image);
      var imageNode = item.querySelector('.complete-the-look__media img');

      if (!imageNode || !image) return;
      if (imageNode.dataset.ctlSrc === image && imageNode.dataset.ctlSrcset === imageSrcset) return;

      imageNode.dataset.ctlSrc = image;
      imageNode.dataset.ctlSrcset = imageSrcset;
      if (imageSrcset) {
        imageNode.setAttribute('srcset', imageSrcset);
        imageNode.setAttribute('sizes', '(max-width: 640px) 46vw, 260px');
      } else {
        imageNode.removeAttribute('srcset');
        imageNode.removeAttribute('sizes');
      }
      imageNode.src = image;
    }

    updateFooter() {
      var totalNode = this.querySelector('.complete-the-look__total');
      var button = this.querySelector('.complete-the-look__button');
      var footer = this.querySelector('.complete-the-look__footer');
      var selectedCount = this.getSelectedStates().length;
      var statusMessage = this.getStatusMessage();
      var message = this.querySelector('.complete-the-look__message');

      if (totalNode) {
        totalNode.innerHTML = this.renderTotalHtml();
      }

      if (button) {
        button.disabled = !(selectedCount > 0 && !this.loading);
        button.textContent = this.loading ? 'Adding...' : this.config.buttonLabel || 'Add selected';
      }

      if (statusMessage) {
        if (!message && footer) {
          message = document.createElement('p');
          footer.appendChild(message);
        }

        if (message) {
          message.className = 'complete-the-look__message is-error';
          message.setAttribute('role', 'status');
          message.textContent = statusMessage;
        }
      } else if (message) {
        message.remove();
      }
    }

    getCartSectionIds() {
      if (this.cartSectionIds) {
        return this.cartSectionIds.slice();
      }

      var ids = [];

      document.querySelectorAll('[id^="shopify-section-"]').forEach(function (section) {
        var id = section.id.replace('shopify-section-', '');
        if (/cart|header|drawer/i.test(id)) {
          uniquePush(ids, id);
        }
      });

      [
        'cart-drawer',
        'header',
        'cart-icon-bubble',
        'cart-notification',
        'mini-cart'
      ].forEach(function (id) {
        uniquePush(ids, id);
      });

      this.cartSectionIds = ids;
      return ids.slice();
    }

    getBundledCartSectionIds() {
      return this.getCartSectionIds().slice(0, 5);
    }

    replaceNodeContents(currentNode, nextNode) {
      if (!currentNode || !nextNode) return false;

      currentNode.innerHTML = nextNode.innerHTML;
      return true;
    }

    replaceSection(sectionId, html) {
      if (!sectionId || !html) return false;

      var currentSection = document.getElementById('shopify-section-' + sectionId);
      var nextDocument = parseHtml(html);
      var nextSection = nextDocument.getElementById('shopify-section-' + sectionId);

      if (currentSection && nextSection) {
        return this.replaceCartFragments(nextDocument);
      }

      if (currentSection) {
        return this.replaceCartFragments(nextDocument);
      }

      return this.replaceCartFragments(nextDocument);
    }

    replaceCartFragments(nextDocument) {
      var replaced = false;

      CART_FRAGMENT_SELECTORS.forEach(function (selector) {
        var currentNodes = document.querySelectorAll(selector);
        var nextNodes = nextDocument.querySelectorAll(selector);

        if (!currentNodes.length || !nextNodes.length) return;

        currentNodes.forEach(function (currentNode, index) {
          var nextNode = nextNodes[index] || nextNodes[0];
          if (this.replaceNodeContents(currentNode, nextNode)) {
            replaced = true;
          }
        }, this);
      }, this);

      return replaced;
    }

    replaceSectionHtml(sectionHtmlById) {
      var replaced = false;

      if (!sectionHtmlById || typeof sectionHtmlById !== 'object') return replaced;

      Object.keys(sectionHtmlById).forEach(function (sectionId) {
        if (this.replaceSection(sectionId, sectionHtmlById[sectionId])) {
          replaced = true;
        }
      }, this);

      return replaced;
    }

    replaceBundledSections(sections) {
      return this.replaceSectionHtml(sections);
    }

    async fetchHtml(path) {
      var response = await fetch(path, {
        headers: {
          Accept: 'text/html'
        }
      });

      if (!response.ok) return '';
      return response.text();
    }

    async replaceFromCartPageFallback() {
      var currentPageHtml = await this.fetchHtml(currentSectionsUrl()).catch(function () {
        return '';
      });

      if (currentPageHtml && this.replaceCartFragments(parseHtml(currentPageHtml))) {
        return true;
      }

      var cartPageHtml = await this.fetchHtml(localizedPath('cart')).catch(function () {
        return '';
      });

      if (!cartPageHtml) return false;

      return this.replaceCartFragments(parseHtml(cartPageHtml));
    }

    updateCartCountElement(element, count) {
      if (!element) return;

      var countText = String(count);
      var targets = [];

      [
        'data-count',
        'data-cart-count',
        'data-cart-item-count',
        'data-cart-items-count',
        'data-cart-count-number',
        'data-header-cart-count',
        'data-cart-bubble',
        'data-cart-icon-bubble'
      ].forEach(function (attribute) {
        if (element.hasAttribute(attribute)) {
          element.setAttribute(attribute, countText);
        }
      });

      if (element.children.length) {
        CART_COUNT_TARGET_SELECTORS.forEach(function (selector) {
          element.querySelectorAll(selector).forEach(function (target) {
            uniquePush(targets, target);
          });
        });
      }

      if (!targets.length && element.children.length && element.matches(CART_COUNT_ELEMENT_SELECTOR)) {
        var fallbackTarget = element.querySelector('span:not(.visually-hidden):not(.sr-only), span');
        if (fallbackTarget && !fallbackTarget.children.length) {
          targets.push(fallbackTarget);
        }
      }

      if (!targets.length) {
        if (element.children.length) {
          this.revealCartCountElement(element);
          return;
        }
        targets.push(element);
      }

      targets.forEach(function (target) {
        if (isSvgElement(target) || target.closest('svg')) return;
        if (target.children.length) return;
        var wasAriaHidden = target.getAttribute('aria-hidden') === 'true';
        target.textContent = countText;
        this.revealCartCountElement(target);
        if (wasAriaHidden) {
          target.setAttribute('aria-hidden', 'true');
        }
      }, this);

      this.revealCartCountElement(element);
    }

    createCartCountBubble(count) {
      var countText = String(count);
      var bubble = document.createElement('div');
      var visibleCount = document.createElement('span');
      var screenReaderText = document.createElement('span');

      bubble.className = 'cart-count-bubble m-cart-count-bubble';
      bubble.setAttribute('data-cart-count-bubble', countText);
      visibleCount.setAttribute('aria-hidden', 'true');
      visibleCount.setAttribute('data-cart-count', countText);
      visibleCount.textContent = countText;
      screenReaderText.className = 'visually-hidden';
      screenReaderText.textContent = countText + ' items';

      bubble.appendChild(visibleCount);
      bubble.appendChild(screenReaderText);

      return bubble;
    }

    ensureCartCountBubble(count) {
      if (count <= 0) return;

      var self = this;
      var containers = document.querySelectorAll(CART_ICON_CONTAINER_SELECTOR);

      containers.forEach(function (container) {
        if (!container || isSvgElement(container) || container.closest('svg')) return;
        if (!isLikelyCartIconContainer(container)) return;

        if (container.matches(CART_COUNT_ELEMENT_SELECTOR)) {
          self.updateCartCountElement(container, count);
          self.revealCartCountElement(container);
          return;
        }

        var existingBubble = container.querySelector(
          '.cart-count-bubble, [data-cart-count-bubble], .m-cart-count-bubble, .m-cart-count, .m-cart-icon__count'
        );

        if (existingBubble) {
          self.updateCartCountElement(existingBubble, count);
          self.revealCartCountElement(existingBubble);
          return;
        }

        var createdBubble = self.createCartCountBubble(count);
        container.appendChild(createdBubble);
        self.revealCartCountElement(createdBubble);
      });
    }

    revealCartCountElement(element) {
      var current = element;
      var depth = 0;

      while (current && depth < 2) {
        current.hidden = false;
        current.removeAttribute('hidden');
        current.removeAttribute('aria-hidden');
        current.classList.remove('hidden', 'is-empty', 'm:hidden');
        if (current.matches && current.matches(CART_COUNT_ELEMENT_SELECTOR)) {
          break;
        }
        current = current.parentElement;
        depth += 1;
      }
    }

    updateCartJsonScript(cart) {
      if (!cart) return;

      document.querySelectorAll('[data-cart-json], script[type="application/json"][data-cart]').forEach(function (script) {
        script.textContent = JSON.stringify(cart);
      });
    }

    syncThemeCartState(cart) {
      if (!cart) return;

      window.cart = cart;

      if (window.MinimogTheme) {
        window.MinimogTheme.cart = cart;
      }

      if (window.FoxTheme) {
        window.FoxTheme.cart = cart;
      }
    }

    updateCartEmptyState(cart) {
      if (!cart || cart.item_count == null) return;

      var isEmpty = Number(cart.item_count) <= 0;
      document.querySelectorAll('#MinimogCartDrawer, #MinimogCart, m-cart-drawer, m-cart').forEach(function (element) {
        element.classList.toggle('m-cart--empty', isEmpty);
      });
    }

    async refreshCartDom(cart, alreadyReplaced) {
      var replaced = Boolean(alreadyReplaced);
      if (!replaced) {
        replaced = await this.replaceFromCartPageFallback();
      }

      this.updateCartCounters(cart);
      this.updateCartEmptyState(cart);
      this.updateCartJsonScript(cart);
      this.syncThemeCartState(cart);

      return replaced;
    }

    async fetchCart() {
      var response = await fetch(localizedPath('cart.js'), {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return null;
      return response.json();
    }

    updateCartCounters(cart) {
      if (!cart || cart.item_count == null) return;

      var count = Number(cart.item_count) || 0;
      var self = this;

      document.querySelectorAll(CART_COUNT_SELECTOR).forEach(function (element) {
        self.updateCartCountElement(element, count);
      });

      this.ensureCartCountBubble(count);
    }

    dispatchCartEvents(addResponse, cart) {
      var detail = {
        open: true,
        cart: cart,
        product: addResponse
      };

      document.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          bubbles: true,
          detail: { product: addResponse }
        })
      );

      if (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart: cart }
          })
        );
      }

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: true }
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: detail
        })
      );

      document.dispatchEvent(
        new CustomEvent('ajaxCart:updated', {
          bubbles: true,
          detail: detail
        })
      );
    }

    async callThemeCartApi(cart) {
      var api = window.MinimogTheme && window.MinimogTheme.Cart;
      if (!api) return false;

      var usedApi = false;

      if (typeof api.refreshCart === 'function') {
        await api.refreshCart();
        usedApi = true;
      }

      if (typeof api.renderNewCart === 'function') {
        await api.renderNewCart();
        usedApi = true;
      }

      if (cart && window.MinimogEvents && typeof window.MinimogEvents.emit === 'function') {
        window.MinimogEvents.emit('ON_CART_UPDATE', cart);
      }

      if (typeof api.openCartDrawer === 'function') {
        api.openCartDrawer();
        usedApi = true;
      }

      return usedApi;
    }

    openCartDrawerByElementMethod() {
      var drawer = document.querySelector('#MinimogCartDrawer, m-cart-drawer, cart-drawer');
      if (!drawer) return false;

      return ['openCartDrawer', 'open', 'show'].some(function (methodName) {
        if (typeof drawer[methodName] === 'function') {
          drawer[methodName]();
          return true;
        }

        return false;
      });
    }

    openCartDrawerFallback() {
      var trigger = document.querySelector(CART_OPEN_TRIGGER_SELECTOR);

      if (trigger) {
        trigger.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          })
        );
      }
    }

    async refreshCartUi(addResponse) {
      var replaced = this.replaceBundledSections(addResponse && addResponse.sections);

      var cart = await this.fetchCart().catch(function () {
        return null;
      });

      await this.refreshCartDom(cart, replaced);
      this.dispatchCartEvents(addResponse, cart);

      window.setTimeout(
        async function () {
          var openedByTheme = await this.callThemeCartApi(cart).catch(function () {
            return false;
          });

          if (!openedByTheme && !this.openCartDrawerByElementMethod()) {
            this.openCartDrawerFallback();
          }
        }.bind(this),
        80
      );
    }

    async handleSubmit() {
      if (this.loading) return;

      var selectedStates = this.getSelectedStates();

      if (!selectedStates.length) {
        this.errorMessage = 'Please select at least one available item.';
        this.updateFooter();
        return;
      }

      var quantitiesByVariantId = {};
      selectedStates.forEach(function (state) {
        var variantId = Number(state.selectedVariant.id);
        quantitiesByVariantId[variantId] = (quantitiesByVariantId[variantId] || 0) + 1;
      });

      var items = Object.keys(quantitiesByVariantId).map(function (variantId) {
        return {
          id: Number(variantId),
          quantity: quantitiesByVariantId[variantId]
        };
      });

      this.loading = true;
      this.errorMessage = '';
      this.updateFooter();

      try {
        var sectionIds = this.getBundledCartSectionIds();
        var payload = {
          items: items
        };

        if (sectionIds.length) {
          payload.sections = sectionIds;
          payload.sections_url = currentSectionsUrl();
        }

        var response = await fetch(localizedPath('cart/add.js'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        var data = await response.json().catch(function () {
          return {};
        });

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Could not add these items to the cart.');
        }

        await this.refreshCartUi(data);
      } catch (error) {
        this.errorMessage = error.message || 'Could not add these items to the cart.';
      } finally {
        this.loading = false;
        this.updateFooter();
      }
    }
  }

  customElements.define(ELEMENT_NAME, CompleteTheLook);
})();
